import { useMutation } from "react-query";
import { useRequest } from "../contexts/request";

const useUploadGuessImage = (props) => {
  const { post } = useRequest();
  
  return useMutation(
    async ({ imageFile }) => {
      const f = new FormData();
      f.append("image", imageFile);
      f.append("feature", "image-guess");
      const {
        json: { data },
      } = await post("cdn/image", { body: f });

      return data;
    },
    { ...props }
  );
};

export { useUploadGuessImage };
